
<div>
  <VueFileAgent
     ref="fileAgent"
    :multiple="true"
    :deletable="true"
    :meta="true"
    :accept="'image/*'"
    :maxSize="'400MB'"
    :maxFiles="maxFiles"
    :helpText="selectText"
    :errorText="{
      type: errorMessage,
      size: errorSize,
    }"
    :thumbnailSize="120"
    :theme="'list'"
     v-model="fileRecords"
     @select="filesSelected($event)"
     @input="fileInput($event)"
     @upload="fileUpload($event)"
     @beforedelete="onBeforeDelete($event)"
     @delete="onDelete($event)"
  ></VueFileAgent>


</div>
